// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export interface GeneratedAnalyticsMetadataAutosuggestComponent {
  name: 'awsui.Autosuggest';
  label: string;
  properties: {
    disabled: string;
  };
}
